<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>카테고리 등록</strong></div>
			<h2 class="h_sub">카테고리 등록</h2>
		</div>

    <CategoryManageCreateForm/>
  </div>
</template>

<script>
import CategoryManageCreateForm from '@/components/admin/etc/CategoryManageCreateForm.vue';

export default {
  components: {
    CategoryManageCreateForm
  }
}
</script>
<style lang="">
    
</style>